module.exports = __webpack_public_path__ + "static/media/Map.c9532941.jpg";